<template>
  <div id="project-form">
    <v-container>
      <v-flex xs12 v-if="!showProjectDetailsForm">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="name"
            :rules="nameRules"
            label="Name"
            required
          ></v-text-field>
          <v-text-field
            v-model="description"
            :rules="descriptionRules"
            label="Description"
            required
            textarea
          ></v-text-field>
          <v-text-field
            v-model="location"
            :rules="locationRules"
            label="Location"
            required
          ></v-text-field>
          <v-text-field
            v-model="grossRealisation"
            :rules="grossRealisationRules"
            label="Gross Realisation"
            required
          ></v-text-field>
          <v-menu
          :close-on-content-click="false"
          v-model="menu2"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          max-width="290px"
          min-width="290px"
        >
          <v-text-field
            slot="activator"
            v-model="computedDateFormatted"
            label="Completed On"
            hint="DD/MM/YYYY"
            persistent-hint
            prepend-icon="event"
            readonly
          ></v-text-field>
          <v-date-picker v-model="completedOn" no-title @input="menu2 = false"></v-date-picker>
          </v-menu><br>
          Main Image<input type="file" @change="onFileChange($event, 'main')" id="file" name="file">
          <div v-if="imageFile">
            <img :src="imageFile" style="max-width:300px;max-height:300px;"/>
            <v-icon @click="removeImage('main')">fa-times</v-icon>
          </div><br>
          Parallax Image<input type="file" @change="onFileChange($event, 'parallax')" id="parallaxfile" name="parallaxfile">
          <div v-if="parallaxImageFile">
            <img :src="parallaxImageFile" style="max-width:300px;max-height:300px;"/>
            <v-icon @click="removeImage('parallax')">fa-times</v-icon>
          </div><br>
          <v-btn color="green" @click="showAddForm">+ Add Project Details</v-btn><br>
          <div v-if="projectDetailsData.length > 0 && !showProjectDetailsForm" style="width:100%;">
            <!-- <v-card v-for="(item, index) in projectDetailsData" :key="index" color="grey lighten-2">
              <v-container>
                <p class="headline">Title</p>
                <p class="content-text">{{ item.headline }}</h1>
                <p class="headline">Content</p>
                <p class="content-text">{{ item.content }}</p>
                <p class="caption">Modified on: {{ item.modified_on }}</p>
                <p class="caption">Modified by: {{ item.author.email }}</p>
                <v-btn class="primary" @click="showEditForm(item)">Edit Item</v-btn>
                <v-btn dark @click="deleteItem(item, index)">Remove Item</v-btn>
              </v-container>
            </v-card> -->
            <v-data-table
              :headers="headers"
              :items="projectDetailsData"
              hide-actions
              class="elevation-1"
            >
              <template slot="items" slot-scope="props">
                <td>{{ props.item.headline }}</td>
                <!-- <td class="text-xs-right">{{ props.item.name }}</td> -->
                <td class="text-xs-right">{{ props.item.content.substring(0, 100) }}</td>
                <td class="text-xs-right">{{ props.item.modified_on | dateTimeFormat }}</td>
                <td class="text-xs-right">{{ props.item.author.email }}</td>
                <td class="text-xs-right">
                  <v-btn
                    icon
                    class="fa primary small mx-3 white--text"
                    color="grey darken-2"
                    @click="showEditForm(props.item)"
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    class="fa dark small mx-3 white--text"
                    color="grey lighten-1"
                    @click="deleteItem(props.item)"
                  >
                    <v-icon color="black">highlight_off</v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </div>
          <v-btn :disabled="!valid" @click="submit" color="primary">{{ buttonName }}</v-btn>
          <v-btn @click="clear" dark>Clear</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="goBack" dark>Back</v-btn>
        </v-form>
      </v-flex>
      <ProjectDetailsForm
        @addItem="showNewDetailsItem"
        @updateItem="showUpdatedDetailsItem"
        @goBack="showProjectDetailsForm = !showProjectDetailsForm"
        :formTitle = "'Project Details'"
        :buttonName="detailsButtonName"
        :editData="editDetailsData"
        v-else
      />  
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ProjectDetailsForm from '@/components/AboutInputForm'
import Api from '@/api'
import moment from 'moment'

export default {
  props: ['buttonName', 'editData', 'projectId'],
  data () {
    return {
      valid: true,
      name: '',
      nameRules: [
        v => !!v || 'Name is required'
      ],
      description: '',
      descriptionRules: [
        v => !!v || 'Description is required'
      ],
      location: '',
      locationRules: [
        v => !!v || 'Location is required'
      ],
      grossRealisation: '',
      grossRealisationRules: [
        v => !!v || 'Gross Realisation is required'
      ],
      imageFile: '',
      parallaxImageFile: '',
      completedOn: '',
      editDetailsData: null,
      projectDetailsData: [],
      detailsButtonName: 'Add',
      showProjectDetailsForm: false,
      menu2: false,
      headers: [
        {
          text: 'Title',
          align: 'left',
          sortable: false,
          value: 'detailTitle'
        },
        { text: 'Content', align: 'right', value: 'content' },
        { text: 'Modified On', sortable: false, align: 'right', value: 'modifiedOn' },
        { text: 'Modified By', sortable: false, align: 'right', value: 'modifiedBy' },
        { text: 'Edit', sortable: false, align: 'right', value: 'edit' }
      ]
    }
  },
  components: {
    ProjectDetailsForm
  },
  beforeMount () {
    if (this.editData) {
      this.name = this.editData.name
      this.description = this.editData.short_description
      this.location = this.editData.location
      this.grossRealisation = this.editData.gross_realisation
      const value = this.editData.completed_on
      this.completedOn = moment(value).year() + '-' + moment(value).month() + '-' + moment(value).date()
      this.imageFile = 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + this.editData.main_image
      this.parallaxImageFile = 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + this.editData.parallax_image
      this.projectDetailsData = this.editData.projectDetails
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'adminUser/getLoggedInUser'
    }),
    computedDateFormatted: function () {
      return this.formatDate(this.completedOn)
    }
  },
  methods: {
    submit () {
      if (!this.editData) {
        if (this.$refs.form.validate()) {
          const data = {
            name: this.name,
            description: this.description,
            location: this.location,
            gross_realisation: this.grossRealisation,
            completed_on: this.completedOn,
            current_user: this.currentUser,
            project_details: this.projectDetailsData
          }
          const imageInput = this.$el.querySelector('#file')
          const parallaxImageInput = this.$el.querySelector('#parallaxfile')
          this.$emit('addItem', data, imageInput, parallaxImageInput)
        }
      } else {
        if (this.$refs.form.validate()) {
          const data = {
            name: this.name,
            description: this.description,
            location: this.location,
            gross_realisation: this.grossRealisation,
            completed_on: this.completedOn,
            current_user: this.currentUser,
            project_details: this.projectDetailsData
          }
          const imageInput = this.$el.querySelector('#file')
          const parallaxImageInput = this.$el.querySelector('#parallaxfile')
          this.$emit('updateItem', this.editData.id, data, imageInput, parallaxImageInput)
        }
      }
    },
    clear () {
      this.$refs.form.reset()
    },
    goBack () {
      this.$emit('goBack')
    },
    onFileChange (e, type) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      this.createImage(files[0], type)
    },
    createImage (file, type) {
      var reader = new FileReader()
      var vm = this

      reader.onload = (e) => {
        if (type === 'main') {
          vm.imageFile = e.target.result
        } else if (type === 'parallax') {
          vm.parallaxImageFile = e.target.result
        }
      }
      reader.readAsDataURL(file)
    },
    removeImage (e) {
      if (e === 'main') {
        const imageInput = this.$el.querySelector('#file')
        imageInput.value = ''
        this.imageFile = ''
      } else if (e === 'parallax') {
        const imageInput = this.$el.querySelector('#parallaxfile')
        imageInput.value = ''
        this.parallaxImageFile = ''
      }
    },
    showAddForm () {
      this.showProjectDetailsForm = true
      this.editDetailsData = null
    },
    showNewDetailsItem (data, imageFile) {
      this.showProjectDetailsForm = false
      data.headline = data.title
      data.author = {'email': ''}
      data.modified_on = ''
      this.projectDetailsData.push(data)
    },
    showEditForm (item) {
      this.showProjectDetailsForm = true
      this.editDetailsData = item
    },
    showUpdatedDetailsItem (detailsId, data, imageFile) {
      this.showProjectDetailsForm = false
      data.headline = data.title
      data.author = {'email': ''}
      data.modified_on = ''
      this.projectDetailsData.forEach((el) => {
        if (el.id === detailsId) {
          this.projectDetailsData[this.projectDetailsData.indexOf(el)] = data
        }
      })
    },
    deleteItem (item) {
      this.projectDetailsData.pop(item)
      const path = '/project/' + this.editData.id + '/' + item.id
      // console.log(path)
      const params = {
        current_user: this.currentUser
      }
      const auth = {username: this.authUsername, password: this.authPassword}
      Api.delete(path, params, auth)
        .then(response => {
          if (response.data.status === 0) {
            this.$swal(response.data.message)
            this.$emit('detailsDeleted')
          } else {
            this.$swal(response.data.message)
          }
        })
        .catch(error => {
          this.$swal(error.toString().substring(0, 100))
        })
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    }
  }
}
</script>

<style scoped>
.card {
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/ProjectInputForm.vue